import React, { useState, useEffect } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useDispatch } from "react-redux";
import {
  setActiveMenu,
  setActiveComponent,
  setDisplayFacilityDDL,
} from "../../reducers/selectedValues";
import "../uiControls/commonStyles.css";

export const FlowMenu = (props) => {
  const menuAction = useDispatch();
  const [expanded, setExpanded] = useState(false);
  const currentUserObj = JSON.parse(localStorage.getItem("currentUser"));
  const menuItems = currentUserObj?.["menus"];

  const menuChangeHandler = (menuKey, levelTitle) => {
    menuAction(setActiveMenu(levelTitle));
    menuAction(setActiveComponent(menuKey));
    menuAction(setDisplayFacilityDDL(!(levelTitle.toLowerCase() === "setup")));
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const findNodeByPath = (tree, targetPath, { caseInsensitive = true } = {}) => {
    if (!Array.isArray(tree) || !targetPath) return null;

    const cmp = (a, b) => {
      if (caseInsensitive) {
        return String(a).toLowerCase() === String(b).toLowerCase();
      }
      return a === b;
    };

    const stack = [...tree]; // iterative DFS to avoid deep recursion limits
    while (stack.length) {
      const node = stack.pop();
      if (node && node.path != null && cmp(node.path, targetPath)) {
        return node;
      }
      if (node && Array.isArray(node.children) && node.children.length) {
        stack.push(...node.children);
      }
    }
    return null;
  }

  useEffect(() => {
    const node = findNodeByPath(menuItems, currentUserObj.defaultMenu);
    if (node !== null) {
      const index = menuItems.findIndex(item => item.menuKey === node.parentMenuKey);
      if (index !== -1) {
        menuChangeHandler(node.title, menuItems[index].title);
        setExpanded(menuItems[index].title);
      }
    }
  }, []);
  
  return (
    <div>
      {menuItems?.map((obj, idx) => (
        <Accordion
          key={idx}
          sx={{
            backgroundColor: "#3a8ddd",
            color: "white",
            boxShadow: "none",
          }}
          expanded={expanded === obj.title}
          onChange={handleChange(obj.title)}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: "white !important" }} />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography sx={{ width: "33%", flexShrink: 0 }}>
              {obj.title}
            </Typography>
          </AccordionSummary>
          <AccordionDetails>
            {obj["hasChild"] &&
              obj.children?.map((childObj, index) => (
                <Typography
                  sx={{ padding: "6px 0px 6px 14px", cursor: "pointer" }}
                  key={index}
                  onClick={() => menuChangeHandler(childObj.title, obj.title)}
                >
                  {childObj.title}
                </Typography>
              ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};
